<template>
  <div class="eol-slider-activity">
    <slot></slot>
    <a-menu
      mode="inline"
      :selected-keys="selectedKeys"
      :open-keys="openKeys"
      @openChange="handleOpenChange"
    >
      <template v-for="route in filteredRoutes">
        <a-menu-item
          v-if="isRouteVisible(route)"
          :key="'/' + school_code + route.path"
          :class="['eol-menu-icon', route.icon]"
        >
          <router-link
            :to="'/' + school_code + route.path + '?id=' + activity_id"
            class="link-line"
          >
            <span>{{ route.name }}</span>
          </router-link>
        </a-menu-item>
      </template>
    </a-menu>
  </div>
</template>

<script>
import { activityRoutes } from "../../src/utils/template";
export default {
  props: {
    activityInfo: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      school_code: localStorage.getItem("schoolCode"),
      routes: activityRoutes,
      openKeys: [],
      selectedKeys: [],
      activity_id: "",
    };
  },
  computed: {
    // 获取所有子路由
    filteredRoutes() {
      return this.routes.children || [];
    },
    // 获取course_task数组
    courseTaskList() {
      return (this.activityInfo && this.activityInfo.course_task) || [];
    }
  },
  created() {
    this.activity_id = this.$route.query.id;
    this.updateMenuState(this.$route.path);
  },
  watch: {
    // 监听路由变化，动态更新选中的菜单和展开的菜单
    $route(to) {
      this.updateMenuState(to.path);
    },
  },
  methods: {
    // 判断路由是否可见（根据course_task数组）
    // 没有code的项目直接显示，有code的才去判断course_task中是否包含
    isRouteVisible(route) {
      // 没有code的路由直接显示
      if (!route.code) return true;
      // 有code的路由需要判断course_task中是否包含
      return this.courseTaskList.some(task => task.code === route.code);
    },
    renderMenuTitle(route) {
      return (
        <span>
          <a-icon type={route.icon} />
          <span>{route.name}</span>
        </span>
      );
    },
    handleOpenChange(keys) {
      this.openKeys = keys;
    },
    updateMenuState(path) {
      // 计算 openKeys，找到 path 对应的所有父级菜单
      this.routes.children.forEach((route) => {
        if (path.indexOf(route.path) > -1) {
          let activePath = "/" + this.school_code + route.path;
          this.openKeys.push(activePath);
          this.selectedKeys = [activePath, path];
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.eol-slider-activity {
  position: fixed;
  width: 180px;
  background: #fff;
  top: 70px;
  left: 0;
  height: calc(100vh - 70px);
  z-index: 1000;
  overflow: hidden;
  overflow-y: scroll;
  .link-line {
    margin-left: 28px;
  }
  /deep/ .ant-menu-item {
    height: 54px;
    line-height: 54px;
    border-bottom: 1px solid #f3f3f3;
    margin: 0;
    padding: 0 0 0 16px !important;
    &::before {
      content: "";
      display: inline-block;
      position: absolute;
      left: 20px;
      top: 50%;
      transform: translateY(-50%);
      width: 14px;
      height: 14px;
      background-size: cover;
      background-position: center;
      background-repeat: no-repeat;
    }
  }
  /deep/.ant-menu-item {
    &.activity {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/activity-set-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/activity-set-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/activity-set.png");
      }
    }
    &.class {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/class-set-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/class-set-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/class-set.png");
      }
    }
    &.practice {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/progress-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/progress-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/progress.png");
      }
    }
    &.t005 {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/t005-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/t005-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/t005.png");
      }
    }
    &.t006 {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/t006-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/t006-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/t006.png");
      }
    }
    &.t007 {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/t007-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/t007-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/t007.png");
      }
    }
     &.allscore {
      &:hover {
        &::before {
          background-image: url("../../assets/image/school/slider/allscore-hover.png");
        }
      }
      &.ant-menu-item-selected {
        &::before {
          background-image: url("../../assets/image/school/slider/allscore-hover.png");
        }
      }
      &::before {
        background-image: url("../../assets/image/school/slider/allscore.png");
      }
    }
  }

  /deep/ &.ant-menu-inline > .ant-menu-item.ant-menu-item-selected a,
  /deep/ &.ant-menu-inline > .ant-menu-item:hover a,
  /deep/ &.ant-menu-inline > .ant-menu-item:hover {
    color: #a82822 !important;
  }
}
.eol-slider-bar {
  display: none;
}
</style>
